














import {Vue, Component} from "vue-property-decorator";
import Terms from "@/component/policy/terms.vue";
import PrivacyPolicy from "@/component/policy/privacy-policy.vue";
import PrivacyPolicy20230410 from "@/component/policy/privacy-policy-20230410.vue";
import PrivacyPolicyArchive from "@/component/policy/privacy-policy-archive.vue";
import SitePolicy from "@/component/policy/site-policy.vue";
import CompanyInfo from "@/component/policy/company-info.vue";

@Component({
    components: {Terms, PrivacyPolicy, PrivacyPolicy20230410, PrivacyPolicyArchive, SitePolicy, CompanyInfo}
})
export default class PolicyBase extends Vue {}
